import React from "react";

const WebFrameDashboard = () => {
  return (
    <div className="w-full h-screen flex items-center justify-center p-4">
      <a
        href="https://cognifog.kentyou.com/eye/ui/dashboard"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-2xl shadow-md transition duration-300"
      >
        Open Cognifog Dashboard
      </a>
    </div>
  );
};

export default WebFrameDashboard;
